import BaseService from './base.service';

export default class PropertiesService {
    static ENDPOINT = '/properties';

    static async addProperty(propertyData) {
        const endpoint = `${this.ENDPOINT}`;
        return BaseService.post(endpoint, propertyData);
    }

    static async editProperty(propertyData) {
        const endpoint = `${this.ENDPOINT}/${propertyData.id}`;
        return BaseService.patch(endpoint, propertyData);
    }

    static async deleteProperty(propertyId) {
        const endpoint = `${this.ENDPOINT}/${propertyId}`;
        return BaseService.delete(endpoint, propertyId);
    }

    static async getPropertyAccessLogs(propertyId) {
        const endpoint = `${this.ENDPOINT}/${propertyId}/access-logs`;
        return BaseService.get(endpoint);
    }
}
